import React from 'react';
import Modal from "react-bootstrap/Modal";
import parse from 'html-react-parser';
import renderLoader from "../base/Loader";
import PropTypes from "prop-types";
import DatePicker, {registerLocale} from "react-datepicker";
import { enUS, hu, sk, cs} from "date-fns/locale/";
import classNames from 'classnames';

registerLocale("sk", sk);
registerLocale("en", enUS);
registerLocale("cz", cs);
registerLocale("hu", hu);

export default class GateCheckboxComponent extends React.Component
{
    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        customerName: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        register: PropTypes.func,
        hasError: PropTypes.func,
        errors: PropTypes.object,
        checkboxes: PropTypes.objectOf(Promise).isRequired
    };

    static defaultProps = {
        errors: {},
        checkboxes: Promise.resolve([]),
        positionId: null
    };

    constructor(props) {
        super(props);
        this.state = {loading: true, show: false, modalTitle: '', modalText: '', };
        this.loadCheckboxes();
    }

    loadCheckboxes = () => {
        this.props.checkboxes.then(checkboxes => {
            let checkboxValues = checkboxes.filter(checkbox => checkbox.selected).map(checkbox => checkbox.id);
            let checkboxDates = {};
            checkboxes.filter(checkbox => checkbox.date && checkbox.document).forEach(checkbox => checkboxDates[checkbox.document.id]= checkbox.document.valid_until)
            sessionStorage.setItem('checkboxes-'+this.props.customerName, JSON.stringify(checkboxValues));
            sessionStorage.setItem('checkbox-dates-'+this.props.customerName, JSON.stringify(checkboxDates));
            this.setState({checkboxes: checkboxes, loading: false, checkboxDates: checkboxDates, defaultCheckboxDates: checkboxDates, checkboxValues: checkboxValues});
        });
    };

    renderCheckboxes = () => {
        let {checkboxes, checkboxDates, checkboxValues} = this.state;
        return checkboxes.map((checkbox)=>{
            if ((this.props.positionId && checkbox.statusPosition === 'hidden') || (!this.props.positionId && checkbox.statusDatabase === 'hidden' )) {
                return null;
            }
            let labelText = checkbox.locale.hasOwnProperty(this.props.language) ? checkbox.locale[this.props.language] : checkbox.locale[Object.keys(checkbox.locale)[0]];
            if(checkbox.document  && checkbox.document.hasOwnProperty('document_versions') && checkbox.document.document_versions && checkbox.document.document_versions.length > 0){

            	let doc =  checkbox.document.document_versions[checkbox.document.document_versions.length-1];

                let documents = checkbox.document.document_versions.filter(item => item.lang === this.props.language);
                if (documents.length > 0) {
                	doc = documents[documents.length-1];
				}

                labelText = (
                    <>
                        {labelText.indexOf('[') !== -1 && labelText.substring(0, labelText.indexOf('['))}
                        <a href={'#'} onClick={() => this.openModal(doc.title, doc.content)}>
                               <strong><u>{labelText.indexOf('[') !== -1 ? labelText.substring(labelText.indexOf('[')+1, labelText.indexOf(']')) : labelText}</u></strong>
                           </a>
                        {labelText.indexOf('[') !== -1 && labelText.substring(labelText.indexOf(']')+1)}
                    </>
                );
            }

            return (
                <>
                    <div className="custom-control custom-checkbox mr-md-5 col-12">
                        <div className={classNames('checkboxes', {'inputHasError' : this.props.hasError('checkbox-document-'+checkbox.id, this.props.errors)})}>
                            <input
                                ref={this.props.register({ required: (this.props.positionId && checkbox.statusPosition === 'required') || (!this.props.positionId && checkbox.statusDatabase === 'required')})}
                                className={'custom-control-input'}
                                name={'checkbox-document-'+checkbox.id} id={'checkbox-document-'+checkbox.id}
                                type={'checkbox'}
                                onClick={(event)=> { if (checkbox.document) { this.saveToSessionStorage(event, checkbox.document.id); }}}
                                checked={checkbox.document && checkboxValues.indexOf(checkbox.document.id) !== -1}
                            />
                            <label className={ 'custom-control-label '}  htmlFor={'checkbox-document-'+checkbox.id} />
                            {labelText}
                            {
                                checkbox.date && (
                                	<>
									&nbsp;
                                    <div className="customDatepickerWrapper">
                                        <DatePicker
                                            onChange={date => this.saveDate(date, checkbox.document.id)}
                                            minDate={new Date()}
                                            dropdownMode={"select"}
                                            dateFormat="P"
                                            locale={this.props.language}
                                            selected={checkboxDates[checkbox.document.id] && new Date(checkboxDates[checkbox.document.id])}
                                            className={"form-control"}
                                        />
                                    </div>
									</>
                                )
                            }
                        </div>
                    </div>
                    {this.props.hasError('checkbox-document-'+checkbox.id, this.props.errors) &&  (<span className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', this.props.language)}</span>)}
                </>
            );
        });
    };

    saveToSessionStorage = (event, document) => {
        let checkboxValues = JSON.parse(sessionStorage.getItem('checkboxes-'+this.props.customerName));
        if(checkboxValues.indexOf(document) === -1){
            checkboxValues.push(document);
        } else {
            checkboxValues.splice(checkboxValues.indexOf(document),1);
        }
        sessionStorage.setItem('checkboxes-'+this.props.customerName, JSON.stringify(checkboxValues));
        this.setState({checkboxValues: checkboxValues});
    };

    saveDate = (date, id) => {
    	let dateString = date ? date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate() : this.state.defaultCheckboxDates[id];
        let checkboxDates = JSON.parse(sessionStorage.getItem('checkbox-dates-'+this.props.customerName));
        checkboxDates[id] = dateString;
        sessionStorage.setItem('checkbox-dates-'+this.props.customerName, JSON.stringify(checkboxDates));
        this.setState({checkboxDates: checkboxDates})
    };


    render() {
        if (this.state['loading']) {
            return renderLoader();
        }
        const { show, modalTitle, modalText} = this.state;
        return (
            <div className="form-group">
                <div>
                    {this.renderCheckboxes()}
                </div>
                <Modal show={show} onHide={this.handleClose} animation={false}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{parse(modalText)}</Modal.Body>
                </Modal>
            </div>
        );
    }

    handleClose = () => {
        this.setState({show: false});
    };

    openModal = (title, text) => {
        this.setState({
            modalTitle: title,
            modalText: text,
            show: true
        });
    }
}
